import * as Label from '@radix-ui/react-label'
import { forwardRef, type InputHTMLAttributes, type ReactNode } from 'react'
import { CloseIcon } from '../../../icons'

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string
  icon?: ReactNode
  error?: string
  id?: string
  reset?: () => void
}

export const Input = forwardRef<HTMLInputElement, InputProps>(({ label, id, icon, error, reset, ...props }, ref) => {
  return (
    <div className="ap:w-full ap:flex ap:flex-col ap:gap-sm">
      {label && (
        <Label.Root className="ap:text-[14px] ap:font-semibold ap:text-content-primary" htmlFor={id}>
          {label}
        </Label.Root>
      )}
      <div className="ap:relative ap:bg-background ap:border ap:border-stroke-primary ap:disabled:bg-surface-accent ap:w-full ap:text-base ap:rounded-md">
        {icon && <div className="ap:absolute ap:top-lg ap:left-xl">{icon}</div>}
        <input
          id={id}
          ref={ref}
          {...props}
          className={`ap:w-full ap:h-full ap:py-lg ap:bg-transparent ap:disabled:text-content-disabled ap:rounded-md ${icon ? 'ap:px-4xl' : 'ap:px-xl'} ${reset ? 'ap:pr-8' : ''}`}
        />
        {reset && (
          <button
            className="ap:absolute ap:top-1/2 ap:-translate-y-1/2 ap:right-2 ap:cursor-pointer"
            type="button"
            onClick={reset}
          >
            <CloseIcon />
          </button>
        )}
      </div>
      {error && <p className="ap:text-content-danger">{error}</p>}
    </div>
  )
})

Input.displayName = 'Input'
